import React from "react";
import { ProjectMenuDropdownPopper } from "../dropdowns/ProjectMenuDropdownPopper";

export const renderAction = (project) => {
  return <ProjectMenuDropdownPopper data={project} singleProject={false} />;
};
